import { render, staticRenderFns } from "./PortfolioAccessControl.vue?vue&type=template&id=61de893c&"
import script from "./PortfolioAccessControl.vue?vue&type=script&lang=js&"
export * from "./PortfolioAccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61de893c')) {
      api.createRecord('61de893c', component.options)
    } else {
      api.reload('61de893c', component.options)
    }
    module.hot.accept("./PortfolioAccessControl.vue?vue&type=template&id=61de893c&", function () {
      api.rerender('61de893c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/accessmanagement/PortfolioAccessControl.vue"
export default component.exports